<template>
    <section>
        <section class="search-container">
            <a-form layout="inline" class="m-t-14">
                <a-form-item label="类型名称">
                    <a-input class="search-input" placeholder="请输入" v-model="searchInfo.carTypeName" />
                </a-form-item>
                <a-form-item>
                    <a-button type="primary" @click="search" class="m-r-8"><a-icon type="search" />查询</a-button>
                    <a-button @click="reset" class="m-r-8"><a-icon type="reload" />重置</a-button>
                    <a-button type="primary" @click="showTypeModal">添加类型</a-button>
                </a-form-item>
                 
            </a-form>
        </section>

        <!-- <a-row type="flex" :gutter="20" class="list-card-container" v-if="listMap.length">

            <a-col :span="6" v-for="(item,key) in listMap" :key="key" class="m-t-16">
                <a-row class="list-card-bg">
                    <a-row class="list-wrap">
                        <a-col>
                            <a-row class="list-item" style="padding-bottom:44px">
                               车辆类型： {{item.carTypeName}}
                            </a-row>
                            <a-row class="list-btn-group-position" style="right:14px">
                                <a-button size="small" @click="showTypeModal(item)">编辑</a-button>
                                <a-popconfirm title="确定删除该类型?" @confirm="deleteItem(item.id)"><a-button size="small">删除</a-button></a-popconfirm>
                            </a-row>
                        </a-col>
                    </a-row>
                </a-row>
            </a-col>
        </a-row> -->
        <section class="list-table-container m-t-18" v-if="listMap.length">
            <a-table size="small" :columns="columns" :data-source="listMap" :pagination="{hideOnSinglePage:true}">
                <a slot="action" slot-scope="text,list">
                    <a class="m-r-10" @click="showTypeModal(list)">编辑</a>
                    <a-popconfirm title="确定删除该车辆类型?" @confirm="deleteItem(list.id)">删除</a-popconfirm>
                </a>
                
            </a-table>
        </section>
        <empty v-else :height="430" />

        <!-- modal -->
        <a-modal centered width="660px" class="modal-container" :title="typeModal.title" v-model="typeModal.visible" :footer="false" :destroyOnClose="true">
            
           <a-form :form="form">
               <a-form-item :label-col="{span:4}" :wrapper-col="{span:18}" label="类型名称">
                   <a-input placeholder="请输入" v-decorator="['carTypeName',{rules:[{required:true,message:'类型名称不能为空'}]}]" class="form-input"></a-input>
               </a-form-item>
               
    
               <a-row class="form-btn-group">
                   <a-button class="btn-save" @click="submit" ><a-icon type="save" />保存</a-button>
                   <a-button class="btn-cancel"  @click="typeModal.visible = false">取消</a-button>
               </a-row>
           </a-form>

        </a-modal>
    </section>
    
</template>

<script>
const columns = [
    {title:'序号',dataIndex:'key',align:'center',key:'key'},
    {title:'车辆类型名称',dataIndex:'carTypeName',align:'center',key:'carTypeName'},
    {title:'创建时间',dataIndex:'createTime',align:'center',key:'createTime'},
    {title:'操作',align:'center',scopedSlots:{customRender: "action"}}
]
import empty from "@/components/empty"
export default {
    data(){
        return{
            columns,
            listMap:[],
            searchInfo:{},
            typeModal:{
                visible:false,
                title:'添加'
            },
            carTypeId:''
        }
    },
    components:{empty},
    beforeCreate(){
        this.form = this.$form.createForm(this)
    },
    created(){
        this.queryCarTypeList()
    },
    methods:{
        showTypeModal(list){
            this.typeModal.visible = true
            
            this.carTypeId = list ? list.id : ''
            this.typeModal.title = this.carTypeId ? '编辑车辆类型' : '新增车辆类型';
            this.backfillForm(list)
        },
        backfillForm(list){
            this.$nextTick(() =>{
                this.form.setFieldsValue({
                    carTypeName:list.carTypeName
                })
            })
        },
        //查询车辆类型列表
        queryCarTypeList(){
            let params =  {...this.searchInfo}
            params.current = this.pageNum
            this.$api.queryCarTypeList(params).then(res =>{
                if(res.code === 200){
                    this.listMap = res.data || []
                    this.listMap.forEach((item,ind) =>{
                        item.key = ind + 1
                    })
                }
            })
        },
        //搜索重置
        reset(){
            this.searchInfo = {}
            this.pageNum = 1
            this.queryCarTypeList()
        },
        search(){
            this.pageNum = 1
            this.queryCarTypeList()
        },
        //添加和编辑提交表单
        submit(){
           this.form.validateFields((err,formData) => {
               if(!err){
                   if(this.carTypeId){
                       formData.id = this.carTypeId
                   }
                   this.$api[this.carTypeId ? 'updateCarType' : 'insertCarType'](formData).then(res =>{
                       if(res.code === 200){
                           this.typeModal.visible = false
                           this.queryCarTypeList()
                       }
                   })
               }
           }) 
        },
        //删除
        deleteItem(id){
            this.$api.deleteCarType({id}).then(res =>{
                if(res.code === 200){
                    this.queryCarTypeList()
                }
            })
        }
    }
}
</script>